import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrending3"><Path d="M16.5 6.5H21.5V11.5M20.9722 7.05L13 15L9 11L2.5 17.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTrending3;
